'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _events = require('pricing-pages-unified-ui/events.yaml');

var _events2 = _interopRequireDefault(_events);

var _Tracking = require('pricing-pages-unified-ui/constants/Tracking');

var _Raven = require('Raven');

var _Raven2 = _interopRequireDefault(_Raven);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  events: _events2.default,
  properties: {
    namespace: _Tracking.APP
  },
  lastKnownEventProperties: ['screen', 'subscreen'],
  onError: function onError(err) {
    _Raven2.default.captureMessage('usage-tracker-js event error', {
      extra: {
        message: err.message
      }
    });
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/utils/CommonTrackerProperties.js
// module id = 792
// module chunks = 3 4